/**
 * kc-extreme-page.js
 *
 * KC Extreme strategy (strategies/kc-extreme-htf.md) — Daily and 4H:
 *   Long:  candle wick hits the lower Keltner(20,2) band while the next
 *          timeframe up's 50 SMA is sloping up
 *   Short: candle wick hits the upper Keltner(20,2) band while the next
 *          timeframe up's 50 SMA is sloping down
 *   4H signals use the Daily 50 SMA; Daily signals use the Weekly 50 SMA.
 * A signal stays on while consecutive candles keep hitting the band.
 * Detection lives in server/indicator-engine.js → computeKcTouch() and
 * server/data-service.js.
 */

import React from 'react';
import StrategySignalsPage from './strategy-signals-page';
import { fetchKcExtremeData } from '../services/server-api';

const TF_LABELS = { daily: 'Daily (Weekly trend)', fourHour: '4H (Daily trend)' };

function fmt(v) {
  return v != null ? `$${v.toLocaleString(undefined, { maximumFractionDigits: 6 })}` : '—';
}

function renderDetails(entry) {
  const isLong = entry.state === 'long';
  const cls    = isLong ? 'bull' : 'bear';
  const bars   = entry.kcTouchBars || 1;
  return (
    <>
      <div className="mtf-ind-row">
        <span className="mtf-ind-label">{isLong ? 'Lower band' : 'Upper band'}</span>
        <span className={`mtf-ind-value ${cls}`}>{fmt(entry.kcBand)}</span>
      </div>
      <div className="mtf-ind-row">
        <span className="mtf-ind-label">Hitting band</span>
        <span className="mtf-ind-value zone">{bars} candle{bars === 1 ? '' : 's'} in a row</span>
      </div>
      <div className="mtf-ind-row">
        <span className="mtf-ind-label">Higher-TF 50 SMA</span>
        <span className={`mtf-ind-value ${cls}`}>{isLong ? '↑ rising' : '↓ falling'}</span>
      </div>
    </>
  );
}

function KcExtremePage() {
  return (
    <StrategySignalsPage
      config={{
        title:      'KC Extreme',
        icon:       '📏',
        subtitle:   'Candle wick hits the lower/upper Keltner(20,2) band · next timeframe up 50 SMA sloping with the trade',
        fetchFn:    fetchKcExtremeData,
        timeframes: ['daily', 'fourHour'],
        tfLabels:   TF_LABELS,
        renderDetails,
      }}
    />
  );
}

export default KcExtremePage;
